export const deleteKbUser = `mutation($email : String!){
    deleteKbUser(input : $email)
  }`
